'use client';

import { styled } from 'styled-components';
export const HiddenInput = styled.input.withConfig({
  displayName: "HiddenInput",
  componentId: "asurion-ui-react__sc-lj317d-0"
})(["position:fixed;opacity:0;pointer-events:none;"]);